import { ReactComponent as SearchIcon } from '../../../../../assets/icons/search.svg'

import styles from './search-tab.module.scss'
interface ISearchTabProps {
    search: string
    setSearch: React.Dispatch<React.SetStateAction<string>>
}

function SearchTab(props: ISearchTabProps) {
    const { search, setSearch } = props

    return (
        <label className={styles.searchTab} htmlFor="search">
            <SearchIcon className={styles.searchTab__icon} alt="Search" />
            <input
                className={styles.searchTab__input}
                name="search"
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
        </label>
    )
}

export default SearchTab
